import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const MoonRiverLogoFooter = () => (
  <img
    src="/logo-full-transparent.png"
    alt="Moon River Real Estate"
    className="h-16 w-auto object-contain"
  />
);

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1A1A1B] border-t border-[#E5B1A1]/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <MoonRiverLogoFooter />
            </Link>
            <p className="text-[#A3A3A0] max-w-md leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#E5B1A1] text-xs uppercase tracking-[0.2em] font-medium mb-6">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="/#about" className="text-[#A3A3A0] hover:text-[#FFFFFF] transition-colors">
                  {t('nav.about')}
                </a>
              </li>
              <li>
                <a href="/#portfolio" className="text-[#A3A3A0] hover:text-[#FFFFFF] transition-colors">
                  {t('nav.portfolio')}
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-[#A3A3A0] hover:text-[#FFFFFF] transition-colors">
                  {t('nav.contact')}
                </a>
              </li>
              <li>
                <Link to="/login" className="text-[#A3A3A0] hover:text-[#FFFFFF] transition-colors">
                  {t('nav.clientArea')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#E5B1A1] text-xs uppercase tracking-[0.2em] font-medium mb-6">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-[#A3A3A0]">
                <Mail size={18} strokeWidth={1.5} className="text-[#E5B1A1]" />
                <span>contact@moonriverrealestate.com</span>
              </li>
              <li className="flex items-center gap-3 text-[#A3A3A0]">
                <Phone size={18} strokeWidth={1.5} className="text-[#E5B1A1]" />
                <span>+33 6 59 93 13 84</span>
              </li>
              <li className="flex items-center gap-3 text-[#A3A3A0]">
                <Phone size={18} strokeWidth={1.5} className="text-[#E5B1A1]" />
                <span>+238 915 86 31</span>
              </li>
              <li className="flex items-start gap-3 text-[#A3A3A0]">
                <MapPin size={18} strokeWidth={1.5} className="text-[#E5B1A1] mt-1" />
                <span>Palmarejo, Cap-Vert</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#E5B1A1]/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#A3A3A0]">
            © {new Date().getFullYear()} Moon River Real Estate. {t('footer.rights')}
          </p>
          <div className="flex gap-6">
            <a href="/legal" className="text-sm text-[#A3A3A0] hover:text-[#FFFFFF] transition-colors">
              {t('footer.legal')}
            </a>
            <a href="/privacy" className="text-sm text-[#A3A3A0] hover:text-[#FFFFFF] transition-colors">
              {t('footer.privacy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
